import styled from 'styled-components';

export const WidgetContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.light};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.primary.white};
  padding: 15px;
  height: 348px;
  overflow: hidden;
`;

export const WidgetProjectsContainer = styled(WidgetContainer)`
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 3;
  height: 348px;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 15px;
  height: 35px;
`;

export const TableContainer = styled.div`
  overflow: auto;
  height: calc(100% - 35px);
`;

export const TableHeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TableHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectWrapper = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    min-width: 100px;
    border: 1px solid ${({ theme }) => theme.colors.primary.blue};
    .ant-select-selection-item {
      color: ${({ theme }) => theme.colors.primary.blue};
    }
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: ${({ theme }) => theme.colors.primary.blue};
    box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.primary.blue}4a;
  }
  .ant-select-arrow {
    width: 20px;
    height: 20px;
    div {
      margin: 0;
    }
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    padding-right: 30px;
  }
`;
